import { render, staticRenderFns } from "./PayrollSummery.vue?vue&type=template&id=fcab924e&scoped=true&"
import script from "./PayrollSummery.vue?vue&type=script&lang=js&"
export * from "./PayrollSummery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcab924e",
  null
  
)

export default component.exports